import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SG_APP_DTL_ATCM_LIST,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";

export const APP_AMD_DTL_ATCM = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const [atcmList, setAtcmList] = useState(comnUtils.getGridData([]));
    const [bfAtcmList, setBfAtcmList] = useState(comnUtils.getGridData([]));

    /*
     * Application eDoc List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Application eDoc List !== 신청서 첨부파일 목록 ==!
        appDtlAtcmList: useGrid({
            defaultSchema: SG_APP_DTL_ATCM_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const bfAppInfo = { ...props.form?.getValues() };
    const bfGrid = {
        // Application eDoc List !== 신청서 첨부파일 목록 ==!
        appDtlAtcmList: useGrid({
            defaultSchema: SG_APP_DTL_ATCM_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Application eDoc Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getAtcmList: useFetch({
            api: (page = grid.appDtlAtcmList.page) => {
                return COMN_APIS.getAtcmList({ ...props.state }, page, grid.appDtlAtcmList.size);
            },
            key: [grid.appDtlAtcmList.page, grid.appDtlAtcmList.size],
            onSuccess: (data) => {
                if (data.atcmList.content!) {
                    setAtcmList(comnUtils.getGridData(data.atcmList.content || []));
                }

                fetch.getBeforeAtcmList.fetch();
            },
            onError: () => {},
            showToast: false,
        }),
        getBeforeAtcmList: useFetch({
            api: (page = bfGrid.appDtlAtcmList.page) => {
                return COMN_APIS.getAtcmList({ ...bfAppInfo }, page, bfGrid.appDtlAtcmList.size);
            },
            key: [bfGrid.appDtlAtcmList.page, bfGrid.appDtlAtcmList.size],
            onSuccess: (data) => {
                if (data.atcmList.content!) {
                    setBfAtcmList(comnUtils.getGridData(data.atcmList.content || []));
                }
            },
            onError: () => {},
            showToast: false,
        }),
        lpcoRprtModal: useFetch({
            api: (appId: string) => {
                return lpcoUtils.getRprtLpco(appId);
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
        }),
    };

    /*
     * Application eDoc Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            handler.getAtcmList();
        },
        // Get Application Item List !== 신청서 품목 목록 조회 ==!
        getAtcmList: (page: number = 0) => {
            grid.appDtlAtcmList.setPage(page);
            fetch.getAtcmList.fetch(page);
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    const render = {
        grid_appAtcmLst: {
            head: {},
            cell: {
                bsopId: (gridProps: any) => {
                    const { binding, rowValues, value } = gridProps;

                    // External URL attachment !== URL 첨부 ==!
                    if (!comnUtils.isEmpty(rowValues.atcdFileUrlAddr)) {
                        return (
                            <Layout direction="col" gap={1}>
                                <Button
                                    onClick={() => {
                                        lpcoUtils.urlFileDownload(rowValues.atcdFileUrlAddr);
                                    }}
                                >
                                    {t("B_DWNL")}
                                </Button>
                            </Layout>
                        );
                    }
                    // Stored file — default FormControl !== 내부 저장 파일 ==!
                    if (rowValues.bsopId != null) {
                        return undefined;
                    }
                    // LPCO Report !== LPCO 보고서 ==!
                    if (rowValues.atcdFileGrpId != null) {
                        return (
                            <Layout direction="col" gap={1}>
                                <Button
                                    onClick={() => {
                                        fetch.lpcoRprtModal.fetch(rowValues.atcdFileGrpId);
                                    }}
                                >
                                    {t("B_LPCO_RPRT")}
                                </Button>
                            </Layout>
                        );
                    }
                    return null;
                    // if (rowValues.bsopId == null) {
                    //     return (
                    //         <Layout direction="col" gap={1}>
                    //             <Button
                    //                 onClick={() => {
                    //                     fetch.lpcoRprtModal.fetch(rowValues.atcdFileGrpId);
                    //                 }}
                    //             >
                    //                 {t("B_LPCO_RPRT")}
                    //             </Button>
                    //         </Layout>
                    //     );
                    // }
                },
            },
            edit: {},
        },
        grid_bfAppAtcmLst: {
            head: {},
            cell: {
                bsopId: (gridProps: any) => {
                    const { binding, rowValues, value } = gridProps;

                    // External URL attachment !== URL 첨부 ==!
                    if (!comnUtils.isEmpty(rowValues.atcdFileUrlAddr)) {
                        return (
                            <Layout direction="col" gap={1}>
                                <Button
                                    onClick={() => {
                                        lpcoUtils.urlFileDownload(rowValues.atcdFileUrlAddr);
                                    }}
                                >
                                    {t("B_DWNL")}
                                </Button>
                            </Layout>
                        );
                    }
                    // Stored file — default FormControl !== 내부 저장 파일 ==!
                    if (rowValues.bsopId != null) {
                        return undefined;
                    }
                    // LPCO Report !== LPCO 보고서 ==!
                    if (rowValues.atcdFileGrpId != null) {
                        return (
                            <Layout direction="col" gap={1}>
                                <Button
                                    onClick={() => {
                                        fetch.lpcoRprtModal.fetch(rowValues.atcdFileGrpId);
                                    }}
                                >
                                    {t("B_LPCO_RPRT")}
                                </Button>
                            </Layout>
                        );
                    }
                    return null;
                    // if (rowValues.bsopId == null) {
                    //     return (
                    //         <Layout direction="col" gap={1}>
                    //             <Button
                    //                 onClick={() => {
                    //                     fetch.lpcoRprtModal.fetch(rowValues.atcdFileGrpId);
                    //                 }}
                    //             >
                    //                 {t("B_LPCO_RPRT")}
                    //             </Button>
                    //         </Layout>
                    //     );
                    // }
                },
            },
            edit: {},
        },
    };

    return (
        <Page>
            <Layout gap={2}>
                <Group>
                    <Group.Body>
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_ELCT_DOC_LST"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group>
                                <Group.Body>
                                    <Grid
                                        {...bfGrid.appDtlAtcmList.grid}
                                        data={bfAtcmList}
                                        render={render.grid_bfAppAtcmLst}
                                    />
                                </Group.Body>
                            </Group>
                        </Layout>
                    </Group.Body>
                </Group>

                <Group>
                    <Group.Body>
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_ELCT_DOC_LST"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group>
                                <Group.Body>
                                    <Grid
                                        {...grid.appDtlAtcmList.grid}
                                        data={atcmList}
                                        render={render.grid_appAtcmLst}
                                    />
                                </Group.Body>
                            </Group>
                        </Layout>
                    </Group.Body>
                </Group>
            </Layout>
        </Page>
    );
};
